import React, { useEffect } from "react";
import MultiFactorAuthentication from "components/auth/MultiFactorAuthentication";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { useMerchantContext } from "lib/contexts/MerchantProvider";

interface UnauthenticatedViewsProps {}

const UnauthenticatedViews: React.FC<UnauthenticatedViewsProps> = ({}) => {
  const {
    actions: { setCheckoutView },
  } = useCheckoutContext();
  const {
    state: { merchant },
  } = useMerchantContext();

  useEffect(() => {
    setCheckoutView("AUTH");
  }, []);

  return (
    <div className="flex w-full flex-col items-center space-y-4 px-3 pt-3 pb-4">
      <MultiFactorAuthentication />
    </div>
  );
};

export default UnauthenticatedViews;
